import React, { FC, useState } from "react";
import { t } from "i18next";
import { FileMetaDataDto } from "@green0meter/api-client";

import { Button } from "@components/base";
import { useDownloadFile, useDownloadSupplierReport } from "@api";
import { useUserStore } from "@store/user";

interface DownloadButton {
  report: FileMetaDataDto;
  isBuyer?: boolean;
}

const DownloadButton: FC<DownloadButton> = ({ report, isBuyer }) => {
  const { user } = useUserStore();
  const [loading, setLoading] = useState(false);
  const { downloadFile, downloadFileEnabled } = useDownloadFile(user);
  const { downloadSupplierReport } = useDownloadSupplierReport(user);
  const { pathName, name } = report;

  const handleFileDownload = async (): Promise<void> => {
    setLoading(true);
    try {
      if (isBuyer && report?.procurementSupplierName) {
        await downloadSupplierReport({ path: pathName, name });
      } else {
        await downloadFile({ path: pathName, name });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    downloadFileEnabled && (
      <Button
        key={`${report.fileId}-download`}
        size="small"
        onClick={handleFileDownload}
        isLoading={loading}
      >
        {t("common.download")}
      </Button>
    )
  );
};

export default DownloadButton;
